var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.95 0 0 3.95 333.96 239.04)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 -0.02 -41.81)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(122,122,122)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-49.43, -39.22)",
    d: "M 34.51 41.56 V 37.87 a 1 1 0 0 1 1 -1 H 63.35 a 1 1 0 0 1 1 1 v 3.69 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 0 8.72)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(163,163,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-49.44, -51.91)",
    d: "M 63.12 62.43 H 35.75 a 1.24 1.24 0 0 1 -1.24 -1.23 V 41.39 H 64.36 V 61.2 A 1.23 1.23 0 0 1 63.12 62.43 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 -25.85 -8.5)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,137,214)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -6.32,
    y: -4.135,
    rx: 0,
    ry: 0,
    width: 12.64,
    height: 8.27
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 -25.85 26.65)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,137,214)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -6.32,
    y: -4.135,
    rx: 0,
    ry: 0,
    width: 12.64,
    height: 8.27
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 26.45 26.65)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,137,214)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -6.32,
    y: -4.135,
    rx: 0,
    ry: 0,
    width: 12.64,
    height: 8.27
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 26.45 -8.5)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -6.32,
    y: -4.135,
    rx: 0,
    ry: 0,
    width: 12.64,
    height: 8.27
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.98 0 0 3.98 7.46 0.26)",
    id: "graphics"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_linear-gradient_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 49.11,
    y1: 66.54,
    x2: 80.07,
    y2: 3.81
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_linear-gradient_5)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-51.31, -49.79)",
    d: "M 63.24 37 H 58.46 c -1.74 2.21 -19.64 24.83 -20.07 25.57 H 63 a 1.23 1.23 0 0 0 1.23 -1.24 V 38 A 1 1 0 0 0 63.24 37 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/Blob.ccfe7a285486db5f7eecfe2194a2159f.svg";
export { ForwardRef as ReactComponent };